module.exports = __webpack_public_path__ + "img/shareImg1.47820bfe.png";